module.exports = __webpack_public_path__ + "media/customizations/emanuel/back-02dd8645db03a62d27626cafd036da0d.jpg";